import { render, staticRenderFns } from "./ArticleTweet.vue?vue&type=template&id=e3c52aa4&scoped=true"
import script from "./ArticleTweet.vue?vue&type=script&lang=js"
export * from "./ArticleTweet.vue?vue&type=script&lang=js"
import style0 from "./ArticleTweet.vue?vue&type=style&index=0&id=e3c52aa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3c52aa4",
  null
  
)

export default component.exports